import { combineReducers } from 'redux';
import { PAGE_SHOW_LOADING_SPINNER } from 'actions/loadingSpinner/constants';
import createReducer from 'utils/createReducer';

const showLoadingSpinnerPage = createReducer(false, {
  [PAGE_SHOW_LOADING_SPINNER]: (draft, { payload }) =>
    payload.showLoadingSpinnerPage,
});

export default combineReducers({
  showLoadingSpinnerPage,
});
